import Image from "next/image";
import React from "react";

export interface SubCardIconsProps {
  level: "AFL" | "NRL" | "BBL" | "Full";
}
export type SubcardItem = string[];

export interface SubCards {
  [key: string]: SubcardItem[];
}

const subCardIcons = {
  NRL: [
    ["/images/nrl.svg", "nrl"],
    [
      "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
      "whatsapp",
    ],
  ],
  BBL: [
    ["/images/bbl.svg", "bbl"],
    [
      "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
      "whatsapp",
    ],
  ],
  CRICKET: [
    ["/images/bbl.svg", "bbl"],
    [
      "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
      "whatsapp",
    ],
  ],
  Full: [
    ["/images/nrl.svg", "nrl"],
    ["/images/bbl.svg", "bbl"],
    [
      "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
      "whatsapp",
    ],
  ],
  SCPB: [
    ["/images/nrl.svg", "nrl"],
    ["/images/bbl.svg", "bbl"],
    [
      "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg",
      "whatsapp",
    ],
  ],
};

const SubCardIcons = ({ level }: SubCardIconsProps) => {
  return (
    <div className="flex flex-row align-center mx-auto gap-6">
      {
        //@ts-ignore
        subCardIcons[level]?.map(function (item: SubcardItem) {
          return (
            <div className={"bg-transparent"} key={`${level}-${item[1]}`}>
              <div className={`relative ${item[1]} card-icon`}>
                <Image
                  src={item[0]}
                  color="green"
                  alt={`access to ${level} content`}
                  fill
                />
              </div>
            </div>
          );
        })
      }
    </div>
  );
};

export default SubCardIcons;
